export const task =process.env.NODE_ENV=="development"?"devtask.appsdeployer.com":'task.appsdeployer.com';
export const cx = process.env.NODE_ENV=="development"?"devcx.appsdeployer.com":"cx.appsdeployer.com";
export const idea = process.env.NODE_ENV=="development"?"devidea.appsdeployer.com":"idea.appsdeployer.com";
export const form = process.env.NODE_ENV=="development"?"http://localhost:3000":"forms.appsdeployer.com";
export const drive = process.env.NODE_ENV=="development"?"http://localhost:3002":"drive.appsdeployer.com";

//both
export const risk ='www.appsdeployer.com/riskdeployer'
export const whiteboards = "whiteboard.appsdeployer.com/";